import type { Recurrence } from 'src/types/Schedules';

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function formatRecurrence(r: Recurrence): string {
  const time = r.time;
  switch (r.kind) {
    case 'daily':
      return `Daily at ${time}`;
    case 'weekly': {
      const days = (r.days_of_week || []).map((d) => DAY_NAMES[d]).join(', ');
      return `Weekly on ${days} at ${time}`;
    }
    case 'monthly':
      return `Monthly on day ${r.day_of_month} at ${time}`;
    case 'once':
      return `Once at ${time}`;
    default:
      return r.kind;
  }
}

export function formatNextFire(isoUtc: string): { absolute: string; relative: string } {
  const d = new Date(isoUtc);
  const absolute = d.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
  const now = Date.now();
  const diffMs = d.getTime() - now;
  if (diffMs < 0) return { absolute, relative: 'overdue' };
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 60) return { absolute, relative: `in ${diffMin}m` };
  const diffHrs = Math.floor(diffMin / 60);
  if (diffHrs < 24) return { absolute, relative: `in ${diffHrs}h` };
  const diffDays = Math.floor(diffHrs / 24);
  return { absolute, relative: `in ${diffDays}d` };
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  const secs = Math.round(ms / 1000);
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  const remSecs = secs % 60;
  return `${mins}m ${remSecs}s`;
}
